<!--
    @name: widget-rate
    @description：widget-rate
    @author: ZengWei
    @date: 2022-03-25 09:30
-->
<template>
  <el-rate
    v-model="element.value"
    :show-text="element.config['show-text']"
    :allow-half="element.config['allow-half']"
    :count="element.config.max"
    :disabled="disabled || element.config.disabled"
  ></el-rate>
</template>

<script>
import {Rate} from "element-ui"
import formItemMinix from "@/custom-component/form/newParser/scripts/formItemMinix";

export default {
  name: "WidgetRate",
  components: {
    'el-rate':Rate
  },
  mixins: [formItemMinix],
  props: ['element', 'disabled', 'displayData'],
  data() {
    return {}
  },
  methods: {},
}
</script>

<style scoped>

</style>
